import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { BeltType } from '../model/model'
import { RootState } from './store'
import { fetchUserRatings } from './userSlice'

const sliceName = 'video'

export type FetchVideosResponseType = {
  error: Array<string>
  result: boolean
  videos: Array<{
    id: string
    post_id: string
    vimeo_id: string
    title: string
    description: string
    create_date: string
    thumbnail_id: string
    image: string
    upload_status: null | string
    tags: Array<string>
  }>
}

type FetchVideosRequestType = {
  query: string
  page: number
  interval: number
}

type SliceStateType = {
  fetching: boolean
  category: Array<BeltType>
  idMap: Record<string, string>
  nameMap: Record<string, string>
}

const initialState: SliceStateType = {
  fetching: false,
  category: [],
  idMap: {},
  nameMap: {}
}

export const fetchVideos = createAsyncThunk<FetchVideosResponseType, FetchVideosRequestType>(
  `${sliceName}/fetch`,
  async (args, thunkAPI) => {
    const state = (thunkAPI.getState() as RootState).config

    try {
      const response = await fetch(
        `${state.setting.root}video?q=${args.query}&p=${args.page}&interval=${args.interval}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': state.setting.nonce
          }
        }
      )
        .then((res) => res.json())
        .then((json) => {
          return json as FetchVideosResponseType
        })

      return response
    } catch (e) {
      return thunkAPI.rejectWithValue({})
    }
  }
)

export type FinishVideoRequestType = {
  id: string
  beltID: number
  status: 'start' | 'complete'
}

export type FinishVideoResponseType = {
  result: boolean
  error: Array<string>
}

export const updateTutorialVideo = createAsyncThunk<FinishVideoResponseType, FinishVideoRequestType>(
  `${sliceName}/updateTutorialVideo`,
  async (args, thunkAPI) => {
    const state = (thunkAPI.getState() as RootState).config

    try {
      const response = await fetch(`${state.setting.root}tutorial/${args.id}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': state.setting.nonce
        },
        body: JSON.stringify({ status: args.status })
      })
        .then((res) => res.json())
        .then((json) => {
          return json as FinishVideoResponseType
        })

      if ('complete' === args.status) {
        thunkAPI.dispatch(
          fetchUserRatings({
            beltID: args.beltID,
            studentID: state.view_student?.studentID
          })
        )
      }

      return response
    } catch (e) {
      return thunkAPI.rejectWithValue({})
    }
  }
)

export const videoSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchVideos.pending, (state) => {
      state.fetching = true
    })

    builder.addCase(fetchVideos.fulfilled, (state) => {
      state.fetching = false
    })
  }
})
